import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { PageType } from '../interfaces/types';

const StyledDiv = (selected: boolean) => selected ? styled.div`
  padding: 10px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: black;
  background-color: #D2F825;
  border-radius: 8px;
  font-weight: bold;
` : styled.div`
  padding: 10px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: white;
  font-weight: bold;
`

const MenuItem = (props: {
  content: string;
  onClick: () => void;
  id: PageType;
}) => {
  const [selected, setSelected] = useState(false)

  const Div = StyledDiv(selected)
  useEffect(() => {
    if (window.location.pathname.toUpperCase().includes(props.id)) {
      setSelected(true)
    }
  }, [])

  return (
    <Div
      onClick={props.onClick}
    >
      <div>
      {props.content}
      </div>
    </Div>
  )
}

export default MenuItem